import axios from 'axios'
import { API_URL } from './CONSTANT'

// Default API configuration with headers for authorization
const apiConfig = {
  headers: {
    Accept: 'application/json',  // Set the Accept header to expect JSON responses
  },
  // Method to set Authorization header for API requests
  setAuthorization: (token) => {
    apiConfig.headers.Authorization = `Bearer ${token}`;  // Set the Bearer token in the Authorization header
  },
}

// Function to fetch design details by design ID
export const getDesign = async (token, designId) => {
  apiConfig.setAuthorization(token);  // Set authorization token

  try {
    // Make GET request to fetch the design by ID
    const response = await axios.get(`${API_URL}/designer/${designId}`, apiConfig);
    return response;  // Return the response object if successful
  } catch (error) {
    throw error;  // Throw an error if request fails
  }
}

// Function to download the model associated with the design ID
export const downloadModel = async (token, designId) => {
  apiConfig.setAuthorization(token);  // Set authorization token

  try {
    // Make GET request to download the model by design ID
    const response = await axios.get(`${API_URL}/projects/download/${designId}`, apiConfig);
    return response;  // Return the response object if successful
  } catch (error) {
    throw error;  // Throw an error if request fails
  }
}

// Function to update project data by project ID
export const updateProjectData = async (token, projectID, data) => {
  apiConfig.setAuthorization(token);  // Set authorization token

  const options = {
    method: 'POST',  // Set method to POST for updating data
    url: `${API_URL}/designer/${projectID}`,  // Target URL with project ID
    headers: apiConfig.headers,  // Use the configured headers (including authorization)
    data,  // Attach the data payload for the update
  }

  try {
    // Make POST request to update project data
    const response = await axios.request(options);
    return response;  // Return the response object if successful
  } catch (error) {
    throw error;  // Throw an error if request fails
  }
}

// Function to check if the user is authenticated (check user)
export const checkUser = async (token) => {
  apiConfig.setAuthorization(token);  // Set authorization token

  const options = {
    method: 'POST',  // Set method to POST for checking user data
    url: `${API_URL}/me`,  // Target URL to verify the user
    headers: apiConfig.headers,  // Use the configured headers (including authorization)
    data: {},  // Empty data object for the request body
  }

  try {
    // Make POST request to check user information
    const response = await axios.request(options);
    return response;  // Return the response object if successful
  } catch (error) {
    throw error;  // Throw an error if request fails
  }
}

// Function to fetch the list of panels available
export const getPanelList = async (token) => {
  apiConfig.setAuthorization(token);  // Set authorization token

  try {
    // Make GET request to fetch the panel list
    const response = await axios.get(`${API_URL}/panels`, apiConfig);
    return response;  // Return the response object if successful
  } catch (error) {
    throw error;  // Throw an error if request fails
  }
}

// Function to fetch panel images from a specific URL
export const getPanelImages = async (url) => {
  try {
    // Make GET request to fetch the panel image with response type as 'blob'
    const response = await axios.get(url, { responseType: 'blob' });
    return response;  // Return the response object if successful
  } catch (error) {
    throw error;  // Throw an error if request fails
  }
}

// Function to fetch project images by project ID
const getProjectImages = async (token, projectId) => {
  apiConfig.setAuthorization(token);  // Set authorization token

  const options = {
    method: 'POST',  // Set method to POST for fetching project images
    url: `${API_URL}/projects/images/${projectId}`,  // Target URL to fetch images by project ID
    headers: apiConfig.headers,  // Use the configured headers (including authorization)
    data: {},  // Empty data object for the request body
  }

  try {
    // Make POST request to fetch project images
    const response = await axios.request(options);
    return response;  // Return the response object if successful
  } catch (error) {
    throw error;  // Throw an error if request fails
  }
}

// Export the getProjectImages function for external usage
export { getProjectImages };

// const LIDAR_URL = `http://localhost:8000`
const LIDAR_URL = `https://lider.dronifyit.com`

export const fetchLidarData = async (lattitude, longitude, address) => {
  try {
    const response = axios.get(`${LIDAR_URL}/aligned-lidar-points?lat=${lattitude}&lon=${longitude}&tileHalfSize=50&address=${address}&filterOutliers=true&zStatisticalMultiplier=10.5`)
    return response;
  } catch (error) {
    throw error
  }
}

export const getLidar = async (lattitude, longitude) => {
  try {
    const response = axios.get(`${LIDAR_URL}/get-lidar?lat=${lattitude}&lon=${longitude}&tileHalfSize=50`)
    return response;
  } catch (error) {
    throw error
  }
}

export const fetchGTI = async (lattitude, longitude, tilt, azimuth) => {
  try {
    const response = await axios.get(`${LIDAR_URL}/get-gti?lat=${lattitude}&lon=${longitude}&tilt=${tilt}&azimuth=${azimuth}`)
    // const response = await axios.get(`https://re.jrc.ec.europa.eu/api/v5_2/seriescalc?lat=${lattitude}&lon=${longitude}&raddatabase=PVGIS-NSRDB&startyear=2015&endyear=2015&angle=${tilt}&aspect=${azimuth}&outputformat=json`)    
    return response;
  } catch (error) {
    throw error
  }
}

export const fetchProduction = async (params) => {
  try {
    const response = await axios.post(`${LIDAR_URL}/get-segment-productions`, params)
    return response;
  } catch (error) {
    throw error;
  }
} 

export const fetchTOF = async (params) => {
  try {
    const response = await axios.post(`${LIDAR_URL}/get-tof`, params);
    return response.data.results;    
  } catch (error) {
    throw error
  }
}